import PetMissingInformationForm from '../PetMissingInformationForm';
import { GridItem } from '@flos/react-ui';
import { useRecoilValue } from 'recoil';
import { allCoverablesAtom } from '../../../../recoil/atoms/allCoverablesAtom';
import { useMemo } from 'react';
import { missingInformationAtom } from '../../../../recoil/atoms/missingInformationAtom';
import _ from 'lodash';
import {
    type PetMissingInformationAndMatchingCoverable,
    petToMissingInfoCoverable
} from '../../../../utils/missingInfoUtil';
import type { PetMissingInformationDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/missingInformation';
import { notUpdatedCoverablesAtom } from '../../../../recoil/atoms/notUpdatedCoverablesAtom';

const PetMissingInformation = (): React.JSX.Element => {
    const allCoverables = useRecoilValue(allCoverablesAtom);
    const notUpdatedCoverables = useRecoilValue(notUpdatedCoverablesAtom);
    const coverables = notUpdatedCoverables ?? allCoverables;
    const missingInformation = useRecoilValue(missingInformationAtom);

    const matchedMissingInformationAndCoverables =
        useMemo((): PetMissingInformationAndMatchingCoverable[] => {
            if (!missingInformation?.pet?.length) return [];
            const petMissingMap: Record<string, PetMissingInformationDTO> =
                missingInformation.pet?.reduce<Record<string, PetMissingInformationDTO>>(
                    (map, missingPet) =>
                        missingPet.fixedId ? _.set(map, missingPet.fixedId, missingPet) : map,
                    {}
                );
            if (_.isEmpty(petMissingMap)) return [];
            return [
                ...(coverables.cats
                    ?.filter((cat) => cat.fixedId && _.get(petMissingMap, cat.fixedId))
                    .map(petToMissingInfoCoverable(petMissingMap)) ?? []),
                ...(coverables.dogs
                    ?.filter((dog) => dog.fixedId && _.get(petMissingMap, dog.fixedId))
                    .map(petToMissingInfoCoverable(petMissingMap)) ?? [])
            ];
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [missingInformation]);

    return (
        <>
            {matchedMissingInformationAndCoverables?.map(
                (matchedMissingInformationAndCoverable) => (
                    <GridItem
                        span={12}
                        key={matchedMissingInformationAndCoverable.missingInformation.fixedId}
                    >
                        <PetMissingInformationForm
                            petMissingDTO={matchedMissingInformationAndCoverable.missingInformation}
                            coverableDTO={matchedMissingInformationAndCoverable.coverable}
                        />
                    </GridItem>
                )
            )}
        </>
    );
};

export default PetMissingInformation;
